import merge from 'deepmerge';

/*
  Use custom merge options as deepmerge concatenates arrays by default which doesn't work
  for our responsive arrays
*/
var mergeOptions = {
    arrayMerge: function (destinationArray, sourceArray) {
        return sourceArray || destinationArray;
    },
};
/**
 * mergeTheme
 *
 * merges two objects in a manner appropriate for our theme or nested part of a theme
 */
function mergeTheme(x, y) {
    if (!y)
        return x;
    return merge(x, y, mergeOptions);
}
/**
 * mergeThemeList
 *
 * merges two or more objects in a manner appropriate for our theme or nested part of a theme
 */
function mergeThemeList() {
    var themes = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        themes[_i] = arguments[_i];
    }
    return merge.all(themes.filter(Boolean), mergeOptions);
}

export { mergeTheme, mergeThemeList };
//# sourceMappingURL=mergeTheme.js.map
